'use es6';

import User from 'FormsCommonComponents/lib/User';
import * as Actions from 'FormsUI/actions/User';
export function user(state = new User(), action) {
  switch (action.type) {
    case Actions.SET_USER:
      return action.user;
    default:
      return state;
  }
}